import {
  SustainabilityMatter,
  SustainabilityMatterId,
  CsrdMatterHierarchy,
} from '@upright/common/model/input/materiality-assessment/types-matters';
import { getMatterById } from '.';

export const esrsSustainabilityMatters: SustainabilityMatter[] = [
  {
    id: SustainabilityMatterId.ENVIRONMENT,
    title: 'Environment',
    parent: undefined,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.SOCIAL,
    title: 'Social',
    parent: undefined,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.GOVERNANCE,
    title: 'Governance',
    parent: undefined,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E1_CLIMATE_CHANGE,
    title: 'Climate change',
    parent: SustainabilityMatterId.ENVIRONMENT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E1_CLIMATE_CHANGE_MITIGATION,
    title: 'Climate change mitigation',
    parent: SustainabilityMatterId.E1_CLIMATE_CHANGE,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E1_CLIMATE_CHANGE_ADAPTATION,
    title: 'Climate change adaptation',
    parent: SustainabilityMatterId.E1_CLIMATE_CHANGE,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E1_ENERGY,
    title: 'Energy',
    parent: SustainabilityMatterId.E1_CLIMATE_CHANGE,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E2_POLLUTION,
    title: 'Pollution',
    parent: SustainabilityMatterId.ENVIRONMENT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E2_POLLUTION_OF_AIR,
    title: 'Pollution of air',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E2_POLLUTION_OF_WATER,
    title: 'Pollution of water',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E2_POLLUTION_OF_SOIL,
    title: 'Pollution of soil',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E2_POLLUTION_OF_LIVING_ORGANISMS_AND_FOOD_RESOURCES,
    title: 'Pollution of living organisms and food resources',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E2_POLLUTION_OF_WATER_AND_SOIL,
    title: 'Pollution of water and soil',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E2_SUBSTANCES_OF_CONCERN,
    title: 'Substances of concern',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E2_SUBSTANCES_OF_VERY_HIGH_CONCERN,
    title: 'Substances of very high concern',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E2_MICROPLASTICS,
    title: 'Microplastics',
    parent: SustainabilityMatterId.E2_POLLUTION,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E3_WATER_AND_MARINE_RESOURCES,
    title: 'Water and marine resources',
    parent: SustainabilityMatterId.ENVIRONMENT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E3_WATER,
    title: 'Water',
    parent: SustainabilityMatterId.E3_WATER_AND_MARINE_RESOURCES,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E3_WATER_WITHDRAWALS,
    title: 'Water withdrawals',
    parent: SustainabilityMatterId.E3_WATER,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E3_WATER_CONSUMPTION,
    title: 'Water consumption',
    parent: SustainabilityMatterId.E3_WATER,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E3_WATER_WITHDRAWALS_AND_CONSUMPTION,
    title: 'Water withdrawals and consumption',
    parent: SustainabilityMatterId.E3_WATER,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E3_WATER_DISCHARGES,
    title: 'Water discharges',
    parent: SustainabilityMatterId.E3_WATER,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E3_WATER_DISCHARGES_IN_THE_OCEANS,
    title: 'Water discharges in the oceans',
    parent: SustainabilityMatterId.E3_WATER,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E3_MARINE_RESOURCES,
    title: 'Marine resources',
    parent: SustainabilityMatterId.E3_WATER_AND_MARINE_RESOURCES,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E3_EXTRACTION_AND_USE_OF_MARINE_RESOURCES,
    title: 'Extraction and use of marine resources',
    parent: SustainabilityMatterId.E3_MARINE_RESOURCES,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_BIODIVERSITY,
    title: 'Biodiversity',
    parent: SustainabilityMatterId.ENVIRONMENT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_DIRECT_DRIVERS_OF_BIODIVERSITY_LOSS,
    title: 'Direct impact drivers of biodiversity loss',
    parent: SustainabilityMatterId.E4_BIODIVERSITY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_CLIMATE_CHANGE,
    title: 'Climate change',
    parent: SustainabilityMatterId.E4_DIRECT_DRIVERS_OF_BIODIVERSITY_LOSS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'In context of biodiversity',
  },
  {
    id: SustainabilityMatterId.E4_LAND_USE_CHANGE_ETC,
    title: 'Land-use change, fresh water-use change and sea-use change',
    parent: SustainabilityMatterId.E4_DIRECT_DRIVERS_OF_BIODIVERSITY_LOSS,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_DIRECT_EXPLOITATION,
    title: 'Direct exploitation',
    parent: SustainabilityMatterId.E4_DIRECT_DRIVERS_OF_BIODIVERSITY_LOSS,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_INVASIVE_ALIEN_SPECIES,
    title: 'Invasive alien species',
    parent: SustainabilityMatterId.E4_DIRECT_DRIVERS_OF_BIODIVERSITY_LOSS,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_POLLUTION,
    title: 'Pollution',
    parent: SustainabilityMatterId.E4_DIRECT_DRIVERS_OF_BIODIVERSITY_LOSS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'In context of biodiversity',
  },
  {
    id: SustainabilityMatterId.LEGACY_E4_IMPACTS_ON_THE_STATE_OF_SPECIES,
    title: 'Impact on the state of species',
    parent: SustainabilityMatterId.E4_BIODIVERSITY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E4_IMPACTS_ON_THE_EXTENT_AND_CONDITION_OF_ECOSYSTEMS,
    title: 'Impacts on the extent and condition of ecosystems',
    parent: SustainabilityMatterId.E4_BIODIVERSITY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_ECOSYSTEMS_AND_SPECIES,
    title: 'Ecosystems and species',
    parent: SustainabilityMatterId.E4_BIODIVERSITY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E4_ECOSYSTEM_SERVICES,
    title: 'Ecosystem services',
    parent: SustainabilityMatterId.E4_BIODIVERSITY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E5_CIRCULAR_ECONOMY,
    title: 'Circular economy',
    parent: SustainabilityMatterId.ENVIRONMENT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E5_RESOURCES_INFLOWS,
    title: 'Resource inflows, including resource use',
    parent: SustainabilityMatterId.E5_CIRCULAR_ECONOMY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.E5_RESOURCE_OUTFLOWS_AND_WASTE,
    title: 'Resource outflows and waste',
    parent: SustainabilityMatterId.E5_CIRCULAR_ECONOMY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E5_RESOURCES_OUTFLOWS,
    title: 'Resource outflows related to products and services',
    parent: SustainabilityMatterId.E5_CIRCULAR_ECONOMY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.LEGACY_E5_WASTE,
    title: 'Waste',
    parent: SustainabilityMatterId.E5_CIRCULAR_ECONOMY,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S1_OWN_WORKFORCE,
    title: 'Own workforce',
    parent: SustainabilityMatterId.SOCIAL,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    title: 'Working conditions',
    parent: SustainabilityMatterId.S1_OWN_WORKFORCE,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_SECURE_EMPLOYMENT,
    title: 'Secure employment',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_WORKING_TIME,
    title: 'Working time',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_ADEQUATE_WAGES,
    title: 'Adequate wages',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_SOCIAL_DIALOGUE,
    title: 'Social dialogue',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_FREEDOM_OF_ASSOCIATION,
    title:
      'Freedom of association, the existence of works councils and the information, consultation and participation rights of workers',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_COLLECTIVE_BARGAINING,
    title: 'Collective bargaining, including rate of workers covered by collective agreements',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_WORK_LIFE_BALANCE,
    title: 'Work-life balance',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_HEALTH_AND_SAFETY,
    title: 'Health and safety',
    parent: SustainabilityMatterId.S1_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_EQUAL_TREATMENT_AND_OPPOTUNITY_FOR_ALL,
    title: 'Equal treatment and opportunity for all',
    parent: SustainabilityMatterId.S1_OWN_WORKFORCE,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_GENDER_EQUALITY_AND_EQUAL_PAY,
    title: 'Gender equality and equal pay for work of equal value',
    parent: SustainabilityMatterId.S1_EQUAL_TREATMENT_AND_OPPOTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_TRAINING_AND_SKILLS,
    title: 'Training and skills development',
    parent: SustainabilityMatterId.S1_EQUAL_TREATMENT_AND_OPPOTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_EMPLOYMENT_AND_INCLUSION_OF_PERSONS_WITH_DISABILITIES,
    title: 'Employment and inclusion of persons with disabilities',
    parent: SustainabilityMatterId.S1_EQUAL_TREATMENT_AND_OPPOTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_MEASURES_AGAINST_VIOLENCE_AND_HARRASMENT_IN_THE_WORKPLACE,
    title: 'Measures against violence and harassment in the workplace',
    parent: SustainabilityMatterId.S1_EQUAL_TREATMENT_AND_OPPOTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_DIVERSITY,
    title: 'Diversity',
    parent: SustainabilityMatterId.S1_EQUAL_TREATMENT_AND_OPPOTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_OTHER_WORK_RELATED_RIGHTS,
    title: 'Other work-related rights',
    parent: SustainabilityMatterId.S1_OWN_WORKFORCE,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_CHILD_LABOUR,
    title: 'Child labour',
    parent: SustainabilityMatterId.S1_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_FORCED_LABOUR,
    title: 'Forced labour',
    parent: SustainabilityMatterId.S1_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_ADEQUATE_HOUSING,
    title: 'Adequate housing',
    parent: SustainabilityMatterId.S1_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_WATER_AND_SANITATION,
    title: 'Water and sanitation',
    parent: SustainabilityMatterId.S1_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S1_PRIVACY,
    title: 'Privacy',
    parent: SustainabilityMatterId.S1_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Own workforce',
  },
  {
    id: SustainabilityMatterId.S2_WORKERS_IN_THE_VALUE_CHAIN,
    title: 'Workers in the value chain',
    parent: SustainabilityMatterId.SOCIAL,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    title: 'Working conditions',
    parent: SustainabilityMatterId.S2_WORKERS_IN_THE_VALUE_CHAIN,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_SECURE_EMPLOYMENT,
    title: 'Secure employment',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_WORKING_TIME,
    title: 'Working time',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_ADEQUATE_WAGES,
    title: 'Adequate wages',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_SOCIAL_DIALOGUE,
    title: 'Social dialogue',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_FREEDOM_OF_ASSOCIATION,
    title:
      'Freedom of association, the existence of works councils and the information, consultation and participation rights of workers',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_COLLECTIVE_BARGAINING,
    title: 'Collective bargaining, including rate of workers covered by collective agreements',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_WORK_LIFE_BALANCE,
    title: 'Work-life balance',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_HEALTH_AND_SAFETY,
    title: 'Health and safety',
    parent: SustainabilityMatterId.S2_WORKING_CONDITIONS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_OTHER_WORK_RELATED_RIGHTS,
    title: 'Other work-related rights',
    parent: SustainabilityMatterId.S2_WORKERS_IN_THE_VALUE_CHAIN,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_EQUAL_TREATMENT_AND_OPPORTUNITY_FOR_ALL,
    title: 'Equal treatment and opportunity for all',
    parent: SustainabilityMatterId.S2_WORKERS_IN_THE_VALUE_CHAIN,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_GENDER_EQUALITY_AND_EQUAL_PAY,
    title: 'Gender equality and equal pay for work of equal value',
    parent: SustainabilityMatterId.S2_EQUAL_TREATMENT_AND_OPPORTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_TRAINING_AND_SKILLS,
    title: 'Training and skills development',
    parent: SustainabilityMatterId.S2_EQUAL_TREATMENT_AND_OPPORTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_EMPLOYMENT_AND_INCLUSION_OF_PERSONS_WITH_DISABILITIES,
    title: 'Employment and inclusion of persons with disabilities',
    parent: SustainabilityMatterId.S2_EQUAL_TREATMENT_AND_OPPORTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_MEASURES_AGAINST_VIOLENCE_AND_HARRASMENT_IN_THE_WORKPLACE,
    title: 'Measures against violence and harassment in the workplace',
    parent: SustainabilityMatterId.S2_EQUAL_TREATMENT_AND_OPPORTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_DIVERSITY,
    title: 'Diversity',
    parent: SustainabilityMatterId.S2_EQUAL_TREATMENT_AND_OPPORTUNITY_FOR_ALL,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_CHILD_LABOUR,
    title: 'Child labour',
    parent: SustainabilityMatterId.S2_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_FORCED_LABOUR,
    title: 'Forced labour',
    parent: SustainabilityMatterId.S2_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_ADEQUATE_HOUSING,
    title: 'Adequate housing',
    parent: SustainabilityMatterId.S2_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_WATER_AND_SANITATION,
    title: 'Water and sanitation',
    parent: SustainabilityMatterId.S2_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S2_PRIVACY,
    title: 'Privacy',
    parent: SustainabilityMatterId.S2_OTHER_WORK_RELATED_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Workers in the value chain',
  },
  {
    id: SustainabilityMatterId.S3_AFFECTED_COMMUNITIES,
    title: 'Affected communities',
    parent: SustainabilityMatterId.SOCIAL,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S3_COMMUNITIES_ECONOMIC_SOCIAL_AND_CULTURAL_RIGHTS,
    title: `Communities' economic, social and cultural rights`,
    parent: SustainabilityMatterId.S3_AFFECTED_COMMUNITIES,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S3_ADEQUATE_HOUSING,
    title: 'Adequate housing',
    parent: SustainabilityMatterId.S3_COMMUNITIES_ECONOMIC_SOCIAL_AND_CULTURAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_ADEQUATE_FOOD,
    title: 'Adequate food',
    parent: SustainabilityMatterId.S3_COMMUNITIES_ECONOMIC_SOCIAL_AND_CULTURAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_WATER_AND_SANITATION,
    title: 'Water and sanitation',
    parent: SustainabilityMatterId.S3_COMMUNITIES_ECONOMIC_SOCIAL_AND_CULTURAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_LAND_RELATED_IMPACTS,
    title: 'Land-related impacts',
    parent: SustainabilityMatterId.S3_COMMUNITIES_ECONOMIC_SOCIAL_AND_CULTURAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_SECURITY_RELATED_IMPACTS,
    title: 'Security-related impacts',
    parent: SustainabilityMatterId.S3_COMMUNITIES_ECONOMIC_SOCIAL_AND_CULTURAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_COMMUNITIES_CIVIL_AND_POLITICAL_RIGHTS,
    title: `Communities civil and political rights`,
    parent: SustainabilityMatterId.S3_AFFECTED_COMMUNITIES,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S3_FREEDOM_OF_EXPRESSION,
    title: 'Freedom of expression',
    parent: SustainabilityMatterId.S3_COMMUNITIES_CIVIL_AND_POLITICAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_FREEDOM_OF_ASSEMBLY,
    title: 'Freedom of assembly',
    parent: SustainabilityMatterId.S3_COMMUNITIES_CIVIL_AND_POLITICAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_IMPACT_ON_HUMAN_RIGHTS_DEFENDERS,
    title: 'Impacts on human rights defenders',
    parent: SustainabilityMatterId.S3_COMMUNITIES_CIVIL_AND_POLITICAL_RIGHTS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_RIGHTS_OF_INDIGENOUS_PEOPLES,
    title: `Rights of indigenous peoples`,
    parent: SustainabilityMatterId.S3_AFFECTED_COMMUNITIES,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Affected communities',
  },
  {
    id: SustainabilityMatterId.S3_FREE_PRIOR_AND_INFORMED_CONSENT,
    title: 'Free, prior and informed consent',
    parent: SustainabilityMatterId.S3_RIGHTS_OF_INDIGENOUS_PEOPLES,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of indigenous peoples',
  },
  {
    id: SustainabilityMatterId.S3_SELF_DETERMINATION,
    title: 'Self-determination',
    parent: SustainabilityMatterId.S3_RIGHTS_OF_INDIGENOUS_PEOPLES,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of indigenous peoples',
  },
  {
    id: SustainabilityMatterId.S3_CULTURAL_RIGHTS,
    title: 'Cultural rights',
    parent: SustainabilityMatterId.S3_RIGHTS_OF_INDIGENOUS_PEOPLES,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of indigenous peoples',
  },
  {
    id: SustainabilityMatterId.S4_CONSUMERS_AND_END_USERS,
    title: 'Consumers and end-users',
    parent: SustainabilityMatterId.SOCIAL,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S4_INFORMATION_RELATED_IMPACTS_FOR_CONSUMERS_AND_END_USERS,
    title: 'Information-related impacts for consumers and end-users',
    parent: SustainabilityMatterId.S4_CONSUMERS_AND_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.S4_PRIVACY,
    title: 'Privacy',
    parent: SustainabilityMatterId.S4_INFORMATION_RELATED_IMPACTS_FOR_CONSUMERS_AND_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_FREEDOM_OF_EXPRESSION,
    title: 'Freedom of expression',
    parent: SustainabilityMatterId.S4_INFORMATION_RELATED_IMPACTS_FOR_CONSUMERS_AND_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_ACCESS_TO_QUALITY_INFORMATION,
    title: 'Access to (quality) information',
    parent: SustainabilityMatterId.S4_INFORMATION_RELATED_IMPACTS_FOR_CONSUMERS_AND_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_PERSONAL_SAFETY_OF_CONSUMERS_END_USERS,
    title: `Personal safety of consumers and end-users`,
    parent: SustainabilityMatterId.S4_CONSUMERS_AND_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_HEALTH_AND_SAFETY,
    title: 'Health and safety',
    parent: SustainabilityMatterId.S4_PERSONAL_SAFETY_OF_CONSUMERS_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_SECURITY_OF_A_PERSON,
    title: 'Security of a person',
    parent: SustainabilityMatterId.S4_PERSONAL_SAFETY_OF_CONSUMERS_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_PROTECTION_OF_CHILDREN,
    title: 'Protection of children',
    parent: SustainabilityMatterId.S4_PERSONAL_SAFETY_OF_CONSUMERS_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_SOCIAL_INCLUSION_OF_CONSUMERS_END_USERS,
    title: `Social inclusion`,
    parent: SustainabilityMatterId.S4_CONSUMERS_AND_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_NON_DISCRIMINATION,
    title: 'Non-discrimination',
    parent: SustainabilityMatterId.S4_SOCIAL_INCLUSION_OF_CONSUMERS_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_ACCESS_TO_PRODUCTS_AND_SERVICES,
    title: 'Access to products and services',
    parent: SustainabilityMatterId.S4_SOCIAL_INCLUSION_OF_CONSUMERS_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.S4_RESPONSIBLE_MARKETING_PRACTICES,
    title: 'Responsible marketing practices',
    parent: SustainabilityMatterId.S4_SOCIAL_INCLUSION_OF_CONSUMERS_END_USERS,
    hierarchy: CsrdMatterHierarchy.ESRS,
    qualifier: 'Of consumers and end-users',
  },
  {
    id: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    title: 'Business conduct',
    parent: SustainabilityMatterId.GOVERNANCE,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.G1_CORPORATE_CULTURE,
    title: 'Corporate culture',
    parent: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.G1_PROTECTION_OF_WHISTEBLOWERS,
    title: 'Protection of whistle-blowers',
    parent: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.G1_ANIMAL_WELFARE,
    title: 'Animal welfare',
    parent: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.G1_POLITICAL_ENGAGEMENT,
    title: 'Political engagement',
    parent: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.G1_MANAGEMENT_OF_RELATIONSHIPS_WITH_SUPPLIERS,
    title: 'Management of relationships with suppliers including payment practices',
    parent: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
  {
    id: SustainabilityMatterId.G1_CORRUPTION_OF_BRIBERY,
    title: 'Corruption and bribery',
    parent: SustainabilityMatterId.G1_BUSINESS_CONDUCT,
    hierarchy: CsrdMatterHierarchy.ESRS,
  },
];

export function isEsrsMatter(matterId: SustainabilityMatterId) {
  const matter = getMatterById(matterId);
  return matter.hierarchy === CsrdMatterHierarchy.ESRS;
}
